import { render, staticRenderFns } from "./ToggleToken.vue?vue&type=template&id=50894cf2&scoped=true"
import script from "./ToggleToken.vue?vue&type=script&lang=js"
export * from "./ToggleToken.vue?vue&type=script&lang=js"
import style0 from "./ToggleToken.vue?vue&type=style&index=0&id=50894cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50894cf2",
  null
  
)

export default component.exports